<template>
    <div class="android">
        <div class="top">
          <img src="/static/img/i_logo.png" alt="" class="icon">
          <p class="title">海纳视频面试</p>
        </div>
        <div class="infos">
            <!-- <strong class="a1">当前浏览器不支持流畅的视频面试</strong> -->
            <div class="single">
                <p class="title">候选人姓名</p>
                <p class="content">{{info.candidateName || '无'}}</p>
            </div>
            <div class="single">
                <p class="title">面试时间（北京时间）</p>
                <p class="content">{{info.beginTime || '无'}}</p>
            </div>
            <div class="single">
                <p class="title">接入码</p>
                <p class="content">{{code}}</p>
            </div>
        </div>
        <div class="box">
            <p class="info">为了更好的面试体验</p>
            <p class="info">请使用电脑浏览器打开并使用</p>
            <el-button class="btn" type="success" size="small" @click="copy(getOrigin(`/#/video?code=${$route.query.code}`))">复制面试链接(<span style="color:#FFEC5D">推荐电脑打开</span>)</el-button>
        </div>
        <div class="code" v-if="!isMulti">
            <p class="title">小程序加入面试</p>
            <img :src="codeUrl" alt="" class="logo" />
            <p class="title">长按识别或保存此图片</p>
            <p class="title">微信『扫一扫』中识别小程序码</p>
            <p class="title">快速参加面试</p>
        </div>
    </div>
</template>
<script>
import toolkit from '@/util/toolkit'
export default {
    data(){
        return{
            info: {},
            codeUrl: '',
            code: '',
            staticUrl: '/static/img/wechatHina.jpg',
            isMulti: false
        }
    },
    created(){
        this.code = this.$route.query.code.replace(/[^0-9]*/g,"")
        this.getInfo(this.code)
        this.getCode(this.code)
    },
    methods:{
        copy(url){
            let oInput = document.createElement('input')
            oInput.value = url
            document.body.appendChild(oInput)
            oInput.select()
            document.execCommand("Copy")
            oInput.style.display = 'none'
            document.body.removeChild(oInput)
            this.$message.success('复制链接成功')
        },
        getCode(code){
            toolkit.post('/interview/info/wsaCode', {
                page: `pages/home-page/main`,
                scene: `${code}`,
                width: 150
            }).then(res => {
                if(res.data.content){
                    this.codeUrl = 'data:image/jpg;base64,' + res.data.content
                }else{
                    this.codeUrl = this.staticUrl
                }
                this.$forceUpdate()
            }).catch(err => {
                this.codeUrl = this.staticUrl
            })
        },
        getOrigin(url){
            return window.location.origin + url
        },
        getInfo(code){
            toolkit.post('/interview/info/detail', {
                connectCode: code
            }).then(res => {
                this.info = res.data
                if(this.info.isMutiInterview == '1'){
                    this.isMulti = true
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.android{
    width: 100%;
    // height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background: #fff;
    .top{
      display: flex;
      align-items: center;
      width: 100%;
      position: absolute;
      top: 10px;
      .icon{
        width: 30px;
        height: auto;
        margin: 10px;
        margin-left: 20px;
      }
      .title{
        font-size: 15px;
        color:#2B313A;
      }
    }
    .infos{
        margin-top: 50px;
        margin-bottom: 0;
        .a1{
            font-size: 20px;
            color: #3E444C;
        }
        .single{
            margin: 20px;
            text-align: center;
            .title{
                color: #8B8F94;
                margin: 8px 0;
            }
            .content{
                color: #3E444C;
                margin: 8px 0;
                font-weight: bold;
            }
        }
    }
    .code{
        text-align: center;
        margin-bottom: 100px;
        .logo{
            width: 150px;
            height: 150px;
        }
        .title{
            margin: 6px 0;
            text-align: center;
            font-size: 13px;
            color: #3E444C;
        }
    }
    .box{
        margin: 5px 0;
        padding: 40px 40px;
        margin-bottom: 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        background: #E9F8F5;
        
        .info{
            padding: 0;
            margin: 6px 0;
            font-size: 16px;
            word-break: break-all;
            font-weight: 500;
            color: #2B313A;
        }
        .btn{
            margin-top: 20px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/content/noVideoMobile.vue